import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import SalesSplash from '../assets/images/Sales Contests - Splash.png';
import Competition from '../assets/images/Sales Contests - Inspire Competition.png';
import Prize from '../assets/images/Sales Contests - Keep Your Eye On the Prize.png';

import '../components/GlobalStyle.css';

import { FadeLoad, FadeLoadDelay, FadeScroll } from '../components/styled/Motion.styled';
import { BPSCheckmarkList, Checkmark } from '../components/styled/Lists';



const SalesContests = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Programs | Sales Contests</title>
                <link rel="canonical" href="https://bestpayment.solutions/sales-contests" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75'>
                <FadeLoad>
                    <Row className='align-items-center justify-content-evenly pt-5 text-center text-md-start'>
                        <Col lg={4} md={6}>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Up Swing - Sales contests</h2>
                            <h1 className='fs-60'>
                                Move inventory fast with sales contests
                            </h1>
                            <p>
                                Increase sales team motivation and drive performance by introducing fun and exciting sales contests with <strong>Up Swing</strong>, our sales contest platform. Turn ambition into results and celebrate every win.
                            </p>
                        </Col>
                        <Col lg={5} md={6}>
                            <FadeLoadDelay>
                                <img src={SalesSplash} width='100%' />
                            </FadeLoadDelay>
                        </Col>
                    </Row>
                </FadeLoad>
            </Container>
            <Container fluid className='py-5'>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} xs={8}>
                        <FadeScroll>
                            <img src={Competition} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={5} xs={12}>
                        <h3 className='fs-48'>Inspire healthy competition & drive sales results</h3>
                        <p>
                            Our tailor-made sales contests are both fun and strategic tools designed to harness enthusiasm, motivate your workforce, and elevate sales. Experience the transformative power of well-crafted healthy competition.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>Enjoy stress-free contest management</h5>
                        <p>
                            Organizing a sales contest can pull you away from core business activities. Allow our experts to shoulder that responsibility. We can handle everything from setting up the contest to distributing enticing rewards like physical and digital prepaid Visa cards, gift cards, exclusive merchandise, and more!
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} xs={12} className='order-2 order-lg-1'>
                        <h3 className='fs-48'>Keep your eye on the prize and leave the details to us</h3>
                        <p>
                            By partnering with us, you empower your team to prioritize your core operations. Trust in our specialized expertise to manage and optimize the contest seamlessly. Our state-of-the-art technology ensures that your sales contest will be a fun, engaging, and easy-to-navigate experience for your sales teams.
                        </p>

                        <h5 className='fw-bold pt-4 fs-24'>Get rewards your sales teams will love</h5>
                        <p>
                            We don't just offer rewards; we curate them to make sure they’re a perfect fit for your team and program. We ensure the prizes are as compelling as the contest itself. Our prize options include:
                        </p>
                        <BPSCheckmarkList>
                            <ul>
                                <li><Checkmark />EGift cards</li>
                                <li><Checkmark />Prepaid Visa Reward Cards</li>
                                <li><Checkmark />Premium merchandise fulfilled by our strategic partner, Amazon</li>
                            </ul>
                        </BPSCheckmarkList>
                        <h5 className='fw-bold pt-4 fs-24'>Transparent & rigorous winner validation</h5>
                        <p>
                            We ensure the authenticity and fairness of sales contests with a thorough validation of winner data before finalizing. We provide multiple communication channels to engage with winners. This ensures they are informed and can claim their well-deserved rewards.
                        </p>
                    </Col>
                    <Col lg={6} xs={12} className='order-1 order-lg-2'>
                        <FadeScroll>
                            <img src={Prize} width='100%' />
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='text-center py-5 bg-cream'>
                <FadeScroll>
                    <Row className="justify-content-center align-items-center py-5">
                        <Col lg={6}>
                            <h3 className='fs-48'>Extensive options for sales contests</h3>
                            <p>
                                Here are just a few ideas of various ways your sales contests can motivate your teams to give their best.
                            </p>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly">
                    <Col lg={3} sm={5} className='py-3'>
                        <h4>Maintain engagement with dynamic promotions</h4>
                        <p>
                            Keep participants continuously engaged and incentivized. Admins can dynamically introduce special promotions or incentives for specific products or across the catalog.
                        </p>
                    </Col>
                    <Col lg={3} sm={5} className='py-3'>
                        <h4>Recognition for top-performers</h4>
                        <p>
                            Recognize top-performing groups with a special treat for their team. The best performers in designated regions or categories can be celebrated on the program platform to boost morale and encourage competition.
                        </p>
                    </Col>
                    <Col lg={3} sm={5} className='py-3'>
                        <h4>Managerial motivation with monthly rewards</h4>
                        <p>
                            Reward sales team managers with monthly awards based on the performance metrics of their teams.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly pt-lg-5">
                    <Col lg={3} sm={5} className='py-3'>
                        <h4>Grand prizes for stellar performers</h4>
                        <p>
                            Reward the best of the best with generous grand prizes based on their performance.
                        </p>
                    </Col>
                    <Col lg={3} sm={5} className='py-3'>
                        <h4>Motivate & monitor with performance leaderboards</h4>
                        <p>
                            Introduce a leaderboard showcasing top performers across different categories or regions.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default SalesContests;